import React, { ReactNode, useState } from 'react';
import dayjs from 'dayjs';

import { FormComponent } from 'components';
import { useInfiniteScroll } from 'hooks';
import { ContentsQuery } from 'queries';
import * as M from 'styles/mobile';
import { SearchContentsFilterType } from 'types';
import { getTypeText } from '../utils';
import * as S from './style';

interface Props {
  title?: ReactNode;
}

function MobileList({ title }: Props) {
  const [filter, setFilter] = useState<SearchContentsFilterType>({});

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    ContentsQuery.useGetInfinite(filter);
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const contents = data ?? [];

  return (
    <>
      <div css={M.stickyTop}>
        {title}
        <FormComponent.Form
          submit={(d: SearchContentsFilterType) =>
            setFilter({ title: d.title || undefined })
          }
        >
          <FormComponent.SearchInput
            name="title"
            placeholder="콘텐츠명으로 검색해주세요"
          />
        </FormComponent.Form>
      </div>
      <div css={M.list}>
        {contents.map((content) => (
          <div
            key={content.id}
            css={[
              M.listItem,
              {
                boxSizing: 'border-box',
                cursor: 'default',
                ':active': { background: 'transparent' },
              },
            ]}
          >
            <div css={S.row}>
              {content.thumbnailUrl ? (
                <img css={S.thumbnail} src={content.thumbnailUrl} alt="" />
              ) : (
                <div css={S.thumbnail} />
              )}
              <div css={S.body}>
                <p css={S.title}>{content.title}</p>
                <p css={S.meta}>{getTypeText(content.type)}</p>
              </div>
              <span css={M.listDate}>
                {dayjs(content.createdAt).format('YYYY-MM-DD')}
              </span>
            </div>
          </div>
        ))}
        {!isLoading && contents.length === 0 && (
          <p css={M.empty}>검색 결과가 없습니다</p>
        )}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default MobileList;
